import { observable } from 'mobx';
import { SetDeliveryMethodUseCase } from '~use-cases/BopisUseCases/SetDeliveryMethodUseCase';
import { TransactionRepository } from '~repositories/TransactionRepository';
import { StoresRepository } from '~repositories/StoresRepository';
import { diContainer } from './diContainer';
import serviceNames from '~setup/StoresService';
import { DeliveryMethods } from '~constants/constants';
import { EditDeliveryViewController } from '~controllers/BopisControllers/EditDeliveryViewController';
import { DeliveryInfoModalViewController } from '~controllers/DeliveryInfoModalViewController';
import { DeliveryMethodsViewController } from '~controllers/DeliveryMethodsViewController';
import { BuyOnlinePickupInStoreFetchDataStrategy } from 'src/internal/strategies/StoresFetchDataStrategies';
import { UserLocationRepository } from '~repositories/UserLocationRepository';
import { Config } from '~domain/entities/Config';

export class ServiceBusController {
    @observable private transactionRepository: TransactionRepository;
    @observable private storesRepository: StoresRepository;
    private editDeliveryViewCtrl: EditDeliveryViewController;
    private editDeliveryModalViewCtrl: DeliveryInfoModalViewController;
    private deliveryMethodsViewCtrl: DeliveryMethodsViewController;
    private locationRepository: UserLocationRepository;
    private configService: Config;

    constructor(transactionRepository: TransactionRepository) {
        this.transactionRepository = transactionRepository;
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.editDeliveryViewCtrl = diContainer.get(serviceNames.editDeliveryViewController);
        this.deliveryMethodsViewCtrl = diContainer.get(serviceNames.deliveryMethodsViewController);
        this.editDeliveryModalViewCtrl = diContainer.get(
            serviceNames.editDeliveryModalViewController
        );
        this.locationRepository = diContainer.get(serviceNames.userLocationRepository);
        this.configService = diContainer.get(serviceNames.config);
    }

    public setDeliveryMethod = async () => {
        const { config } = this.configService;
        if (!config.bopisEnabled) {
            return;
        }
        const deliveryMethod = this.transactionRepository.getDeliveryMethod;
        const selectedStoreId = this.storesRepository.selectedStoreId;
        await new BuyOnlinePickupInStoreFetchDataStrategy().loadStores(
            this.locationRepository.userLocation.geolocation
        );
        const unavailable = this.editDeliveryViewCtrl.getUnavailableItemsSkus();

        if (unavailable.length) {
            await this.transactionRepository.loadTransaction();
        }

        if (DeliveryMethods.BOPIS === deliveryMethod && unavailable.length) {
            this.editDeliveryModalViewCtrl.openModal();

            return;
        }

        if (
            DeliveryMethods.COURIER === deliveryMethod &&
            this.deliveryMethodsViewCtrl.courierStoreNotFound
        ) {
            this.editDeliveryModalViewCtrl.openModal();

            return;
        }

        const c = new SetDeliveryMethodUseCase({
            deliveryMethod: deliveryMethod,
            storeId: selectedStoreId
        });
        c.execute();
    };
}
